import { useEffect, useState } from 'react';

import { request } from '../api';

// Ссылка для превью: локальный blob для только что выбранного файла,
// либо путь на сервере для уже сохранённого изображения.
// version добавляется к серверному пути, чтобы браузер не показывал закешированную старую картинку
const useImagePreview = (image, version) => {
  const [preview, setPreview] = useState(null);

  useEffect(() => {
    if (image instanceof File) {
      const objectUrl = URL.createObjectURL(image);
      setPreview(objectUrl);
      return () => URL.revokeObjectURL(objectUrl);
    }
    if (image?.url) {
      setPreview(`${request}${image.url}${version ? `?v=${version}` : ''}`);
    } else {
      setPreview(null);
    }
  }, [image, version]);

  return preview;
};

export default useImagePreview;
